const pkg     = require('@readcube/pkg').default;
const deps    = require('../deps');
const newLine = require('./line_end');

module.exports = (format, item, mapping) => {
  return pkg.load('@readcube/rcp-citation-export', deps['@readcube/rcp-citation-export'])
    .then(({ asBib, asRis }) => {
      if (format === 'bib') return asBib({ item, newLine, mapping });
      if (format === 'ris') return asRis({ item, newLine, mapping });
      return '';
    });
};
